<template>
  <div>
    <v-card class="mb-16" outlined>
      <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
        Distribution Targets
        <v-spacer></v-spacer>
        <v-btn
          v-if="!readonly"
          @click="updateDistributionTargets"
          color="primary"
          >Update distribution targets</v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :headers="distributionTargetHeaders"
          :items="distributionTargets"
          key="id"
          :footer-props="{
            'items-per-page-options': [15, 50, 100, -1],
          }"
          :items-per-page="15"
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <edit-dialog
      v-if="!readonly"
      :dialog="distributionTargetsDialog"
      @save="saveDistributionTargets"
      @close="distributionTargetsDialog = false"
    >
      <template #title> Update Distribution Targets </template>
      <template #body>
        <select-distribution-targets
          ref="distributionTargets"
          :esvId="esvId"
          :headers="distributionTargetHeaders"
          :preSelectedDistributionTargets="distributionTargets"
        >
        </select-distribution-targets>
      </template>
    </edit-dialog>
  </div>
</template>

<script>
import EditDialog from "@/components/common/EditDialog.vue";
// @ is an alias to /src

export default {
  name: "DistributionTargets",
  components: {
    EditDialog,
    SelectDistributionTargets: () =>
      import("@/components/Organisation/SelectDistributionTargets.vue"),
  },
  props: {
    esvId: Number,
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    esv: {},
    loading: false,
    distributionTargetsDialog: false,

    distributionTargetHeaders: [
      {
        text: "Organisation type",
        value: "organisationType",
        type: "select",
      },
      {
        text: "Shorthand",
        value: "shorthand",
        type: "text",
      },
      {
        text: "Organisation",
        value: "name",
        type: "text",
      },
      {
        text: "Customer Number",
        value: "customerNumber",
        type: "text",
      },
      {
        text: "Region",
        value: "region",
        type: "select",
      },
    ],
    distributionTargets: [],

    headerSelects: [],
    filteredDistributionTargets: [],
  }),
  methods: {
    getDistributionTargets() {
      this.$api
        .getDistributionTargetsAsOrganisation(this.esvId)
        .then((resp) => (this.distributionTargets = resp.data));
    },

    updateDistributionTargets() {
      this.distributionTargetsDialog = true;
    },

    saveDistributionTargets() {
      this.$api
        .updateDistributionTargetsForEsv(
          this.esvId,
          this.$refs.distributionTargets.selectedDistributionTargets
        )
        .then(() => {
          this.$toast.success("Distribution targets have been saved");
          this.getDistributionTargets();
          this.distributionTargetsDialog = false;
        });
    },
  },
  mounted() {
    this.getDistributionTargets();
  },
  watch: {
    readonly: {
      handler() {
        if (this.readonly) {
          this.getDistributionTargets();
        }
      },
    },
  },
};
</script>